module.exports = __webpack_public_path__ + "static/media/contacts_ru.e41c3965.png";